export const environment = {
    region: 'EU',
    regionSelector: true,
    production: true,
    elemental: true,
    deploymentName: 'Legend',
    companyName: 'Elemental',
    website: 'legenddatabase.com',
    converterImageLogo: '/assets/images/elemental/AppLogo.png',
    converterImageLogoSmall: '/assets/images/elemental/AppLogo.png',
    converterWatermarkText: 'ELEMENTAL',
    dashboardLogoLight: '/assets/images/elemental/logo_light_horizontal.png',
    dashboardLogoDark: '/assets/images/elemental/logo_light_horizontal.png',
    dashboardLogoAspectRatio: 5,
    welcomeLogo: '/assets/images/elemental/AppLogo.png',
    welcomePageUrl: 'https://www.legendsmeltingrecycling.com/',
    hasWelcomePageLinks: true,
    baseApiUrl: 'https://app-backend.dev.elemental.biz/api/',
    logLevel: 2,
    versionCheckUrl: 'https://dev.legenddatabase.com/version.json',
    azureMapsKey:
        '1ylXy1Xw4ENtG2DBwAaH1xZiSfmyWF0NwX1yy529xeSTPQVbwJ9yJQQJ99AKACYeBjF03xPwAAAgAZMP2wJ3',
};
